module.exports = __webpack_public_path__ + "static/patient-support-merk-access-program-1c96a6e4ea9a48daead7f4e984395d26.png";